module.exports = __webpack_public_path__ + "housingStatic/img/full_screen.8dad9cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/upper/full_screen.png
// module id = UqsE
// module chunks = 2